import React, { useState } from 'react';
import {
    Box,
    Button,
    Tab,
    Tabs,
    Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';

import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';
import ProjectActivityTable from '../../../components/ReportsProjectActivity/ProjectActivityTable';
import MemberActivityTable from '../../../components/ReportsMemberActivity/MemberActivityTable';

import { FilterwIcon, ExportIcon, OrganizeIcon, ShareIcon, ScheduleIcon } from '../../../icons';

// import DataTable from '../../../components/ReportsMemberActivity/DataTable';
import ProjectReportTable from './report-project-table/ProjectReportTable';
import MemberReportTable from './report-member-table/MemberReportTable';


import DateActivityTable from '../../../components/ReportsDateActivity/DateActivityTable';



import MainTableSec from './MainTableSec';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';

import DataTable from './DataTable';


import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';


import StatsCardRow from './StatsCardRow';
import ShareReport from '../../../components/Projects/ShareReport';
import ScheduleReport from '../../../components/Projects/ScheduleReport';

import ReportFilter from './ReportFilter';

import ExportFile from './ExportFile';
import AppUsageBarChart from './AppUsageBarChart';


function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const organizeOptions = ['Date', 'Project', 'Member'];

const AppsUrlsReport = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0); // Tab value
    const [anchorEl, setAnchorEl] = useState(null); // Menu anchor
    const [selectedOption, setSelectedOption] = useState('Date'); // Organize by

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (option) => {
        setSelectedOption(option);
        setAnchorEl(null);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const statsData = [
        { label: 'Total Application', value: '25' },
        { label: 'Total URLS', value: '45' },
        { label: 'Total Time Spent', value: '30:34:12', color: '#179045' },
        { label: 'Avg. Activity', value: '49%' },
    ];
    const [openShareReport, setOpenShareReport] = useState(false);
    const [openScheduleReport, setOpenScheduleReport] = useState(false);


    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const renderActivityComponent = () => {
        switch (selectedOption) {
            case 'Project':
                return <ProjectReportTable />;
            case 'Member':
                return <MemberReportTable />;
            case 'Date':
            default:
                return (
                    <>
                        <DataTable />
                        <DataTable />

                        {/* <DateActivityTable /> */}
                        {/* <DateActivityTable /> */}
                    </>
                );
        }
    };


    //     const renderActivityComponent = () => {
    //     switch (selectedOption) {
    //       case 'Project':
    //         return <ProjectActivityTable />;
    //       case 'Member':
    //         return <MemberActivityTable />;
    //       case 'Date':
    //       default:
    //         return (
    //           <>
    //             <DateActivityTable />
    //             <DateActivityTable />
    //           </>
    //         );
    //     }
    //   };



    return (
        <>
            <Box>
                <Button
                    onClick={() => navigate('/reports')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        fontFamily: 'Manrope',
                        textTransform: 'capitalize',
                        padding: '0',
                        marginLeft: '-10px'
                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Reports
                </Button>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="600" sx={{ fontFamily: 'Manrope', fontSize: '17px' }}>
                    Apps & URLs report
                </Typography>
                <Box className="d-flex gap-10 align-items-center">
                    {/* Widgets & Scheduled Button */}
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '30px',
                            textTransform: 'capitalize',
                            fontSize: '16px',
                            padding: '8px 16px',
                            background: '#0076FE',
                            fontFamily: 'Manrope',
                            height: '36px',
                            border: 'none',
                            boxShadow: 'none'
                        }}
                        onClick={() => navigate('/scheduled-reports')}
                    >
                        Scheduled reports
                    </Button>

                </Box>
            </Box>


            {/* Tabs */}
            <Box sx={{ borderColor: 'divider', display: 'inline-block' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '8px' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Me" {...a11yProps(0)} />
                        <Tab label="All" {...a11yProps(1)} />
                    </Tabs>
                </Box>
            </Box>
            <Box className="mt-24" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                {/* <DateRangePicker />  */}
                <SingleDatePicker />


                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {/* <Button component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none',}}
            tabIndex={-1} startIcon={<FilterwIcon />}>
            Filter
          </Button> */}
                    <ReportFilter />


                    <Button onClick={() => setOpenShareReport(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none', }}
                        tabIndex={-1} startIcon={<ShareIcon />}>
                        Share
                    </Button>

                    <Button onClick={() => setOpenScheduleReport(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none', }}
                        tabIndex={-1} startIcon={<ScheduleIcon />}>
                        Schedule
                    </Button>

                    {/* <Button component="label" variant="contained"
            sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none',}}
            tabIndex={-1} startIcon={<ExportIcon />}>
            Export
          </Button> */}
                    <ExportFile />
                    {/* <TableDownloadBtn /> */}

                </Box>
                <ShareReport open={openShareReport} onClose={() => setOpenShareReport(false)} />
                <ScheduleReport open={openScheduleReport} onClose={() => setOpenScheduleReport(false)} />
            </Box>



            <Box sx={{ margin: '18px auto 32px' }}>
                <div className="row">
                    <div><StatsCardRow stats={statsData} /></div>
                </div>
            </Box>

            <Box className="card-body p-20 bg-base border rounded-3 mt-24">
                <Typography sx={{ fontSize: '17px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 24px', fontFamily: 'Manrope' }}>Hours spent per apps</Typography>
                <AppUsageBarChart />
            </Box>
            {/* Me Tab */}
            <CustomTabPanel value={value} index={0}>
                <Box className="mt-24">
                    <MainTableSec
                        anchorEl={anchorEl}
                        selectedOption={selectedOption}
                        handleOpenMenu={handleOpenMenu}
                        handleCloseMenu={handleCloseMenu}
                        handleMenuItemClick={handleMenuItemClick}
                        organizeOptions={['Date', 'Project']}
                    /></Box>

                <Box mt={2}>
                    {renderActivityComponent()}
                </Box>
            </CustomTabPanel>

            {/* All Tab */}
            <CustomTabPanel value={value} index={1}>
                <Box className="mt-24">
                    <MainTableSec
                        anchorEl={anchorEl}
                        selectedOption={selectedOption}
                        handleOpenMenu={handleOpenMenu}
                        handleCloseMenu={handleCloseMenu}
                        handleMenuItemClick={handleMenuItemClick}
                        organizeOptions={['Date', 'Project', 'Member']}
                    /></Box>

                <Box mt={2}>
                    {renderActivityComponent()}
                </Box>
            </CustomTabPanel>
        </>
    );
};

export default AppsUrlsReport;
